import React from 'react';
import '../../styles/AnimatedLogo.scss'; // Import the CSS you defined

interface IAnimatedLogoProps
{
	infinite?: boolean;
}

export default function AnimatedLogo(props: IAnimatedLogoProps)
{
	return (
		<div className="spinner-container">
			<svg 
				className={[
					"spinner-svg", 
					"outer",
					...props.infinite ? [] : ["lastIretation"]
				].join(" ")}
				width="216" height="248" 
				viewBox="0 0 216 248" 
				fill="none" 
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M213.49 60.1299L110.51 0.669941C108.96 -0.220059 107.06 -0.220059 105.51 0.669941L2.5 60.1399C0.95 61.0299 0 62.6799 0 64.4699V183.38C0 185.17 0.95 186.82 2.5 187.71L105.51 247.18C107.06 248.07 108.96 248.07 110.51 247.18L213.49 187.72C215.04 186.83 215.99 185.18 215.99 183.39V64.4599C215.99 62.6699 215.04 61.0199 213.49 60.1299V60.1299ZM109.01 18.2799L189 64.4599C190.33 65.2299 190.33 67.1499 189 67.9199L109.02 114.1C108.4 114.46 107.64 114.46 107.02 114.1L27.11 67.8699C25.78 67.0999 25.78 65.1799 27.11 64.4099L107.01 18.2799C107.63 17.9199 108.39 17.9199 109.01 18.2799ZM98.99 127.96C99.61 128.32 99.99 128.98 99.99 129.69L99.9 222.01C99.9 223.55 98.23 224.51 96.9 223.74L17 177.61C16.38 177.25 16 176.59 16 175.88V83.5099C16 81.9699 17.67 81.0099 19 81.7799L98.98 127.96H98.99ZM116.01 129.72C116.01 129 116.39 128.34 117.01 127.99L197 81.9099C198.33 81.1399 200 82.0999 200 83.6399V175.9C200 176.61 199.62 177.27 199 177.63L119.01 223.81C117.68 224.58 116.01 223.62 116.01 222.08V129.72V129.72Z"
					fill="#EBA900"/>
			</svg>

			<svg 
				className={[
					"spinner-svg",
					"reversed",
					"inner",
					...props.infinite ? [] : ["lastIretation"]
				].join(" ")}
				viewBox="0 0 136 154" 
				fill="none" 
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0 47.94V114.9C0 116.69 0.95 118.34 2.5 119.23L33.5 137.11C36.83 139.03 41 136.63 41 132.78V124.7C41 123.63 40.43 122.64 39.5 122.1L16 108.54V50.24C16 49.17 15.43 48.18 14.5 47.64L7.5 43.6C4.17 41.68 0 44.08 0 47.93V47.94Z"
					fill="#EBA900"/>
				<path
					d="M75.51 152.71L133.5 119.23C135.05 118.34 136 116.69 136 114.9V79.11C135.99 75.26 131.82 72.86 128.49 74.78L121.49 78.82C120.56 79.36 119.99 80.35 119.99 81.42V108.55L69.51 137.7C68.58 138.24 68.01 139.23 68.01 140.3V148.38C68.01 152.23 72.18 154.63 75.51 152.71V152.71Z"
					fill="#EBA900"/>
				<path
					d="M128.49 34.93L70.5 1.44997C68.95 0.559971 67.05 0.559971 65.5 1.44997L34.51 19.36C31.18 21.29 31.18 26.1 34.51 28.02L41.51 32.06C42.44 32.6 43.58 32.6 44.51 32.06L68 18.49L118.49 47.64C119.42 48.18 120.56 48.18 121.49 47.64L128.49 43.6C131.82 41.68 131.82 36.86 128.49 34.94V34.93Z"
					fill="#EBA900"/>
			</svg>
		</div>
	);
}
